import jQuery from "jquery";
const $ = jQuery;
const siteHeader = `
<div class="header-top bg-[#fdfeff] top-0 z-[1000] shadow-[0_4px_20px_0_rgba(0,0,0,0.25)]">
<section class="covid-banner" aria-label="PEMGARDA variant protection information">
            <div class="wrapper-div">
              <div class="wrapper__inner">
                  <img src="/uploads/hcp/home/covid-banner-icon.svg" alt="" aria-hidden="true">

                  <div class="content">
                      <p class="main-copy">
                          PEMGARDA&#174; can offer continuous protection* against
                          <span class="txt-orange text-[#ff4e00] font-[700]">emerging SARS-CoV-2 variants, including XFG (Stratus)</span><sup>1,2</sup>
                      </p>

                      <p class="footnote">
                          <span class="footnote-marker">*</span><span>Certain SARS-CoV-2 viral variants may emerge that have substantially reduced susceptibility to PEMGARDA. PEMGARDA may not be effective at preventing COVID-19 caused by these SARS-CoV-2 viral variants.<sup>2</sup></span>
                      </p>
                  </div>
              </div>
            </div>
        </section>
    <div class="container text-[1.1rem]">
        <div class="wrapper flex flex-wrap pb-[0.8rem] justify-between h-[3.6rem] content-end lg:pe-[3rem]">
        <p class="hidden lg:inline-block">For US Residents and Healthcare Professionals only.</p>
        <ul class="w-full lg:w-auto justify-between lg:justify-end flex flex-wrap gap-[1.5rem]">
            <li class="hidden lg:inline-block">
                <a class="inline-flex gap-[.4rem] downloads" target="_blank" href="https://www.invivyd.com/wp-content/uploads/HCP-Fact-Sheet.pdf">Healthcare Providers Fact Sheet</a>
            </li>
            <li class="hidden lg:inline-block">
                <a class="inline-flex gap-[.4rem] downloads" target="_blank" href="https://www.invivyd.com/wp-content/uploads/Patient-Fact-Sheet.pdf">Patient Fact Sheet</a>
            </li>
            <li class="hidden lg:inline-block">
                <a class="inline-flex gap-[.4rem] downloads" target="_blank" href="https://www.invivyd.com/wp-content/uploads/FDA-Letter-of-Authorization.pdf">FDA Letter of Authorization</a>
            </li>
            <li class="hidden lg:inline-block">
                <a class="inline-flex gap-[.4rem] external" href="/patient/"  target="_blank">Visit Patient Site</a>
            </li>
            <li class="hidden lg:inline-block">
                <a class="inline-flex gap-[.4rem] text-gradient decoration-none two font-semibold link-name" href="/hcp/connect-with-us/">Connect With Us <img src="/uploads/site/angle-right-red.svg" alt="Arrow right Icon" /></a>
            </li>
            <li class="icon-bottle has-divider uppercase lg:hidden"><a href="/hcp/order-now/">Order Now</a></li>
            <li class="icon-location uppercase lg:hidden"><a href="/hcp/infusion-center-locator/">Infusion Center Locator</a></li>
        </ul>
        
        </div>
    </div>
    </div>
    <div class="wrap-nav">
    <nav class="container flex items-center gap-2 justify-between">
        <div class="logo max-w-[172px] md:max-w-[175px] md:max-w-[192px] w-full">
        <a class="logo-link" href="/hcp/"><img src="/uploads/pemgarda-logo.png" width="379" height="56" alt="PEMGARDA®"></a>
        </div>
        <div id="site-nav-wrapper" class="nav-items">
        <div class="wrap">
            <ul class="lg:flex flex-wrap items-center gap-y-[10px] md:gap-x-[30px] md:justify-end xl:gap-x-[35px] site-nav">
            <li class="menu-item-has-children">
                <a href="/hcp/about/">About PEMGARDA</a>
                <ul class="sub-menu">
                <li><a href="/hcp/about/">Appropriate patients</a></li>
                <li><a href="/hcp/mechanism-of-action/">MOA</a></li>
                </ul>
            </li>
            <li class="menu-item-has-children">
                <a href="/hcp/trial-design/">Clinical Data</a>
                <ul class="sub-menu">
                <li><a href="/hcp/trial-design/">Trial design</a></li>
                <li><a href="/hcp/efficacy/">Efficacy</a></li>
                <li><a href="/hcp/safety/">Selected <br class="hidden lg:inline-block">adverse reactions</a></li>
                </ul>
            </li>
            <li class="menu-item"><a href="/hcp/dosing/">Dosing</a></li>
            <li class="menu-item-has-children">
                <a href="/hcp/support-resources/">Support & Resources</a>
                <ul class="sub-menu">
                <li><a href="/hcp/support-resources/">Resources</a></li>
                <li><a href="/hcp/patient-support/">Patient support</a></li>
                </ul>
            </li>
            <li class="icon-bottle has-divider uppercase hidden lg:inline-block"><a href="/hcp/order-now/">Order<br>Now</a></li>
            <li class="icon-location uppercase hidden lg:inline-block"><a href="/hcp/infusion-center-locator/">Infusion Center <br> Locator</a></li>
            <li class="lg:hidden">
                <a class="menu-connect-link inline-flex gap-[.4rem] text-gradient decoration-none two font-semibold link-name" target="_blank" href="/hcp/connect-with-us/">Connect With Us</a>
            </li>
            <li class="lg:hidden mb-[1rem]">
                <a class="patient-btn inline-flex gap-[.4rem]" href="/hcp/patient-support/"><span>Patient support</span></a>
            </li>
            <li class="lg:hidden mobile-only">
                <a class="inline-flex gap-[.4rem] downloads" target="_blank" href="https://www.invivyd.com/wp-content/uploads/HCP-Fact-Sheet.pdf">Healthcare Providers Fact Sheet</a>
            </li>
            <li class="lg:hidden mobile-only">
                <a class="inline-flex gap-[.4rem] downloads" target="_blank" href="https://www.invivyd.com/wp-content/uploads/Patient-Fact-Sheet.pdf">Patient Fact Sheet</a>
            </li>
            <li class="lg:hidden mobile-only">
                <a class="inline-flex gap-[.4rem] downloads" target="_blank" href="https://www.invivyd.com/wp-content/uploads/FDA-Letter-of-Authorization.pdf">FDA Letter of Authorization</a>
            </li>
            <li class="lg:hidden mobile-only">
                <a class="inline-flex gap-[.4rem] external" href="/patient/">Visit Patient Site</a>
            </li>
            </ul>
        </div>
        <p class="disclaimer lg:hidden text-center text-[1.4rem]">For US Residents and Healthcare Professionals only.</p>
        </div>
        <button class="flex items-center gap-[11px] text-white lg:hidden font-inter font-semibold text-[15px] leading-1 mobile-nav" aria-label="Hamburder Menu">
        <span></span>
        </button>
    </nav>
</div>
`;

const siteHeaderPatient = `
    <div class="bg-grey">
        <div class="logo-bar mx-auto flex justify-between max-w-[144rem]">
          <img src="/assets/images/shield-icon.svg" alt="" />
          <div class="content logo-bar-content">
            <p class="txt-maroon tracking-[-0.1px]">
              As you consider COVID-19 prevention options, <br /><strong>
                <span class="txt-orange">PEMGARDA&reg; can help protect certain
                  immunocompromised individuals</span></strong>.
            </p>
          </div>
        </div>
      </div>
      <div class="disclaimer-bar flex justify-between max-w-[123rem]">
        <p class="disclaimer">For US residents only.</p>
        <nav class="disclaimer-bar-nav">
          <ul class="flex gap-5">
            <li class="with-border-right">
              <a target="_blank" href="https://invivyd.com/Patient-Fact-Sheet/">
                <p class="with-download-small text-[12px] text-[#000] font-[600] font-avenir">
                  Fact Sheet for Patients, Parents and Caregivers
                </p>
              </a>
            </li>
            <li class="flex">
              <a target="_blank" href="https://invivyd.com/FDA-Letter-of-Authorization/">
                <p class="with-download-small text-[12px] text-[#000] font-[600] font-avenir">FDA Letter of
                  Authorization</p>
              </a>
            </li>
            <li>
              <a href="/hcp">
                <p class="with-full-orange-arrow text-[12px] text-[#000] font-[600] font-avenir">Visit HCP Site</p>
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div class="nav-bar">
        <div class="flex justify-between">
          <div class="nav-bar-logo">
            <a class="logo_container" href="/patient"></a>
          </div>

          <nav class="nav-bar-nav">
            <button aria-controls="menu-list" class="hamburger" type="button" aria-label="Toggle Mobile Menu">
              <span class="open-icon"><img src="/uploads/patient/hamburger.svg" alt="Open Mobile Menu"></span>
              <span class="close-icon"><img src="/uploads/patient/hamburger-x.svg" alt="Open Mobile Menu"></span>
            </button>

            <ul id="menu-list" class="flex nav-menu site-nav">
              <li>
                <a target="_blank"
                  href="/uploads/patient/Invivyd-Care-Patient-Brochure-081826.pdf"
                  class="flex">
                  <p class="with-download">Invivyd Care</p>
                </a>
              </li>
              <li id="frequently-asked-questions-button">
                <a href="/patient/#faq">
                  <p>Frequently Asked Questions</p>
                </a>
              </li>
              <li>
                <a href="/patient/infusion-center-locator/">
                  <p>Infusion Center Locator</p>
                </a>
              </li>
              <li class="only-mob">
                <a target="_blank" href="https://invivyd.com/Patient-Fact-Sheet/">
                  <p class="with-download">
                    Fact Sheet for Patients, Parents and Caregivers
                  </p>
                </a>
              </li>
              <li class="only-mob">
                <a target="_blank" href="https://www.invivyd.com/wp-content/uploads/FDA-Letter-of-Authorization.pdf">
                  <p class="with-download">FDA Letter of Authorization</p>
                </a>
              </li>
              <button class="white-button-black-txt" id="stay-upd-btn">
                STAY UPDATED
              </button>
            </ul>
          </nav>
        </div>
      </div>
`
// document.addEventListener("DOMContentLoaded", () => {
//     // Your interactive code goes here
//     console.log("DOM is completely parsed and ready!");
// });
const header = document.querySelector('header');
header.classList.contains('hcp-header') ? header.innerHTML = siteHeader : header.classList.contains('patient-header') ? header.innerHTML = siteHeaderPatient : ''
// header.innerHTML = siteHeader
const currentPath = window.location.pathname.replace(/\/$/, "");
const hamburger = header.querySelector('.mobile-nav')
const patientHamburger = header.querySelector('.hamburger');
const nav = header.querySelector('.nav-items')
const navLinks = header.querySelectorAll(".site-nav a");
const navLinksHasChildren = header.querySelectorAll(".site-nav li.menu-item-has-children");
const body = document.body;
const html = document.querySelector('html')
const faqScrollTo = document.getElementById("frequently-asked-questions-button"); //Patient Elements
const dialog = document.getElementById("myModal"); //Patient Elements
let lastScrollTop = 0;

window.addEventListener('scroll', function () {
  let current = window.scrollY;
  //(current > 150 && current > lastScrollTop) ? header.classList.add('slide-up'): header.classList.remove('slide-up');
  (current > 30) ? header.classList.add('sticky') : header.classList.remove('sticky');
  lastScrollTop = current;
});

hamburger?.addEventListener('click', (e) => {
  hamburger.classList.toggle('is-active');
  header.querySelector('.wrap-nav').classList.toggle('active-mobile-menu')
  nav.classList.toggle('active')
  body.classList.toggle('freeze');
})

patientHamburger?.addEventListener('click', () => {
  patientHamburger.classList.toggle('active')
  html.classList.toggle('freeze');
  body.classList.toggle('freeze');
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
})


// add the active class for the active page to add the underline using css
navLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    if (link.parentElement.classList.contains('menu-item-has-children')) {
      e.preventDefault();
    }
  })

  const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, "");
  if (currentPath === linkPath) {
    link.parentElement.classList.add("active");
    link.parentElement.parentElement.classList.contains('sub-menu') ? link.parentElement.parentElement.parentElement.classList.add('active') : ''
  }
});

navLinksHasChildren.forEach((el) => {
  const isTouchPrimary = window.matchMedia('(pointer: coarse)').matches;
  const isMousePrimary = window.matchMedia('(pointer: fine)').matches;

  if (isMousePrimary) {
    el.addEventListener('mouseenter', (e) => {
      el.classList.add('is-open');
      el.querySelector('.sub-menu').setAttribute('style', "display: block")
    })
    el.addEventListener('mouseleave', (e) => {
      el.classList.remove('is-open');
      el.querySelector('.sub-menu').setAttribute('style', "display: none")
    })
  } else if (isTouchPrimary) {
    el.addEventListener('click', (e) => {
      el.classList.toggle('is-open');
      el.querySelector('.sub-menu').getAttribute('style') === null || el.querySelector('.sub-menu').getAttribute('style') == 'display: none' ? el.querySelector('.sub-menu').setAttribute('style', "display: block") : el.querySelector('.sub-menu').setAttribute('style', "display: none")
      // el.querySelector('.sub-menu').setAttribute('style', "display: block")
    })
  }
})

if (faqScrollTo != null) {
  const stickyBar = header.nextElementSibling.clientHeight;
  $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
    // Check if the link points to the same domain and page
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      // Find the target element using the link's hash (e.g., #section-id)
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      // Verify the target element exists on the page
      if (target.length) {
        // Prevent default browser jump behavior
        event.preventDefault();

        // Animate the scroll over 800 milliseconds
        $('html, body').animate({
          scrollTop: target.offset().top - stickyBar
        }, 800, function () {
          // Optional: Update the URL hash after the scroll completes
          window.location.hash = this.hash;
        });
      }
    }
  });
}


if (dialog != null) {
  document.getElementById("closeBtn").addEventListener("click", () => {
    dialog.close();
  });
  document.getElementById("stay-upd-btn").addEventListener("click", () => {
    dialog.showModal();
  });
}

const patientMenuLinks = header.querySelectorAll('#menu-list a');

patientMenuLinks.forEach((link) => {
  link.addEventListener('click', () => {
    patientHamburger?.classList.remove('active');
    html.classList.remove('freeze');
    body.classList.remove('freeze');
  });
});